module.exports = __webpack_public_path__ + "static/img/rank_248.8aef9b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_248.png
// module id = yEEU
// module chunks = 1